import {Brick, ErrorFlow, registerBrick} from 'olympe';

/**
 * This brick copies text to the clipboard and handles errors if the operation fails.
 */
export default class CopyTextToClipboard extends Brick {
    /**
     * @override
     * @protected
     * @param {!BrickContext} $
     * @param {string} text
     * @param {function()} forwardEvent
     * @param {function(ErrorFlow)} setErrorFlow
     */
    async update($, [text], [forwardEvent, setErrorFlow]) {
        try {
            await navigator.clipboard.writeText(text);
            forwardEvent();
        } catch (err) {
            setErrorFlow(ErrorFlow.create(`An error was encountered while copying`, 1));
        }
    }
}

registerBrick('019769478c5d70862f4e', CopyTextToClipboard);
